import React from 'react';
import { bool, func, node, number, oneOf, string } from 'prop-types';
import ClassNames from 'classnames';

import './Steps.scss';

const Steps = ({
  children,
  className,
  horizontal,
  onStepClick,
  selectedStep,
  size
}) => {
  const stepItemComponents = React.Children.map(children, (element, i) =>
    React.createElement(
      'div',
      { className: 'Steps__item-wrap', key: element.props.label },
      React.cloneElement(element, {
        number: i + 1,
        onClick: () => onStepClick(i + 1),
        selected: selectedStep === i + 1,
        size
      })
    )
  );

  return (
    <div
      aria-orientation={horizontal ? 'horizontal' : 'vertical'}
      className={ClassNames('Steps', className)}
      role="tablist"
    >
      {stepItemComponents}
    </div>
  );
};

Steps.propTypes = {
  children: node.isRequired,
  className: string,
  horizontal: bool,
  onStepClick: func.isRequired,
  selectedStep: number.isRequired,
  size: oneOf(['small', 'large'])
};

Steps.defaultProps = {
  className: '',
  horizontal: false,
  size: undefined
};

export default Steps;
